import { NgModule } from '@angular/core';
import { ShoppingCart } from "./shopping-cart.component";
import { ShoppingCartActions } from "./shopping-cart.actions";
import { ShoppingCartEventList } from "./shopping-cart-event-list/event-list.presentation"
import { EventListItem } from "./shopping-cart-event-list/event-list-item.presentation"
import { EventListItemLineEditable } from "./shopping-cart-event-list/editable/item-line.presentation"
import { EventListItemHeaderEditable } from "./shopping-cart-event-list/editable/item-header.presentation"
import { EventListItemLineNotEditable } from "./shopping-cart-event-list/not-editable/item-line.presentation"
import { EventListItemHeaderNotEditable } from "./shopping-cart-event-list/not-editable/item-header.presentation"
import { ShoppingCartEventListComponent } from "./shopping-cart-event-list/shopping-cart-event-list.component"
import { CommonModule } from '@angular/common';
import { UiHelperModule } from "../../ui-helper";
import { shoppingcartRouting } from './shopping-cart.routing'


@NgModule({
	imports: [
		UiHelperModule,
		shoppingcartRouting
	],
	declarations: [
		ShoppingCart,
		ShoppingCartEventList,
		EventListItem,
		EventListItemLineEditable,
		EventListItemHeaderEditable,
		EventListItemLineNotEditable,
		EventListItemHeaderNotEditable,
		ShoppingCartEventListComponent
	],
	exports: [
		ShoppingCartEventListComponent
	],
	providers: [
		ShoppingCartActions,

	]
})
export class ShoppingcartModule {
	static forRoot() {
		return {
			ngModule: ShoppingcartModule
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shopping-cart/shopping-cart.module.ts